import { color } from 'framer-motion';
import React, { useState, useEffect } from 'react';
// import newCar from 'assets/images/NewActivityImages/new.png';
import newCar from '../../../../assets/images/NewActivityImages/new.png';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';


const ConvertToWinGame = () => {
  const [score, setScore] = useState(0);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [userAnswer, setUserAnswer] = useState('');
  const [unitSystem, setUnitSystem] = useState('metric');
  const [questionCount, setQuestionCount] = useState(0);
  const [carPosition, setCarPosition] = useState(0);

  const styles = {
    container: {
      fontFamily: 'Segoe UI, sans-serif',
      background: 'linear-gradient(to bottom right, #e0f7fa, #e1bee7)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px'
    },
    box: {
      background: '#fff',
      padding: '2rem',
      borderRadius: '20px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
      textAlign: 'center',
      maxWidth: '500px',
      width: '90%'
    },
    question: {
      fontSize: '2rem',
      margin: '1rem 0',
      color: "black"
    },
    input: {
      padding: '0.5rem',
      fontSize: '1.2rem',
      width: '60%',
      marginTop: '1rem'
    },
    button: {
      padding: '0.5rem 1rem',
      fontSize: '1rem',
      margin: '1rem 0.5rem',
      border: 'none',
      borderRadius: '10px',
      backgroundColor: '#7b1fa2',
      color: '#fff',
      cursor: 'pointer'
    },
    feedback: {
      fontSize: '1.2rem',
      minHeight: '2rem',
      marginTop: '10px'
    },
     road: {
      width: '100%',
      height: '100px',
      background: 'radial-gradient(#666 1px, transparent 2px), #444',
      backgroundSize: '20px 20px',
      borderRadius: '10px',
      marginTop: '2rem',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '6px solid #333',
      borderBottom: '6px solid #333',
      boxShadow: 'inset 0 0 10px #222'
    },
    car: {
      width: '100px',
      transition: 'transform 0.5s ease',
      position: 'absolute',
      bottom: '18px',
      left: '0'
    },
    select: {
      fontSize: '1rem',
      padding: '0.5rem',
      margin: '1rem 0',
      borderRadius: '5px'
    }
  };

  useEffect(() => {
    generateQuestion();
  }, [unitSystem]);

  const generateQuestion = () => {
    let value, correctAnswer, unit;
    if (unitSystem === 'metric') {
      if (Math.random() < 0.5) {
        value = Math.floor(Math.random() * 2000 + 100) / 100;
        correctAnswer = (value * 100).toFixed(0);
        setQuestion(`${value} m → ___ cm`);
        setAnswer(correctAnswer);
      } else {
        value = Math.floor(Math.random() * 500 + 50);
        correctAnswer = (value / 100).toFixed(2);
        setQuestion(`${value} cm → ___ m`);
        setAnswer(correctAnswer);
      }
    } else {
      if (Math.random() < 0.5) {
        value = Math.floor(Math.random() * 100 + 1);
        correctAnswer = (value * 12).toFixed(0);
        setQuestion(`${value} ft → ___ in`);
        setAnswer(correctAnswer);
      } else {
        value = Math.floor(Math.random() * 100 + 10);
        correctAnswer = (value / 12).toFixed(2);
        setQuestion(`${value} in → ___ ft`);
        setAnswer(correctAnswer);
      }
    }
  };

  const handleSubmit = () => {
    if (userAnswer.trim() === answer) {
      setFeedback('✅ Correct!');
      setScore(score + 1);
      setCarPosition(carPosition + 40);
      
           const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      
    } else {
      setFeedback(`❌ Wrong! Correct answer: ${answer}`);
      setCarPosition(Math.max(carPosition - 30, 0));
    }
    setUserAnswer('');
    setQuestionCount(questionCount + 1);
    setTimeout(() => {
      setFeedback('');
      generateQuestion();
    }, 1000);
  };

  return (
    <div style={styles.container}>
      <div style={styles.box}>
        <h3>Convert to Win!</h3>
        <select style={styles.select} value={unitSystem} onChange={(e) => setUnitSystem(e.target.value)}>
          <option value="metric"> (m/cm)</option>
          <option value="imperial">(ft/in)</option>
        </select>
        <div style={styles.question}>{question}</div>
        <input
          type="text"
          style={{
  fontSize: '1rem',
  padding: '6px 12px',
  borderRadius: 6,
  border: '2px solid #f9a825',
  textAlign: 'center',
  width: 'fit-content',
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'block'
}}

          value={userAnswer}
          onChange={(e) => setUserAnswer(e.target.value)}
          placeholder="Enter answer"
        />
        <div>
          <button style={styles.button} onClick={handleSubmit}>Submit</button>
        </div>
        <div style={styles.feedback}>{feedback}</div>
        <div style={{ marginTop: '10px' }}>Score: {score}</div>
        <div style={styles.road}>
          <img
  src={newCar}
  style={{ ...styles.car, transform: `translateX(${carPosition}px)` }}
  alt="car"
/>

        </div>
      </div>
    </div>
  );
};

export default ConvertToWinGame;
